import { CommentDisplay } from './CommentDisplay';
import { InitiativeComment } from '@sonar-software/sonar-core';
import { NewComment } from './NewComment';
import { OffsetPaginatedResource } from '@sonar-software/sonar-ts-types';
import React from 'react';
import { Skeleton } from 'antd';

export interface CommentListProps {
	data: OffsetPaginatedResource<InitiativeComment> | null | undefined;
	initiativeId: number;
}

export const CommentList: React.FC<CommentListProps> = ({ data, initiativeId }) =>
	<Skeleton
		active
		avatar
		loading={ !data }>
		{ data && data.results.map((comment) => <CommentDisplay
			comment={ comment }
			key={ comment.id } />) }
		<NewComment initiativeId={ initiativeId } />
	</Skeleton>;

